module.exports = __webpack_public_path__ + "static/img/LY.c8630759.svg";